<!-- prettier-ignore -->
<div class="table-wrapper" #tableContainer>
  @if (dataSource) {
    <table mat-table [dataSource]="dataSource" matSort [trackBy]="trackByRowId">
      <caption class="table-description">table</caption>
      @for (col of columns; track col.key) {
        <ng-container [matColumnDef]="col.key">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [disabled]="!col.sortable"
            [ngClass]="col.key"
            scope="col"
          >
            {{ col.label }}
          </th>

          <td
            mat-cell
            *matCellDef="let row"
            [matTooltip]="col.tooltip ? col.tooltip(row) : ''"
            [matTooltipDisabled]="!col.tooltip"
            matTooltipPosition="above"
            [style.text-align]="col.align"
            [ngClass]="col.key"
            appEllipsis
          >
            @switch (col.key) {
              @case ('reviewResult') {
                <span
                  class="chip"
                  [ngClass]="{
                    'chip--approved': row.reviewResult === 'approved',
                    'chip--rejected': row.reviewResult === 'rejected',
                    'chip--pending': !row.reviewResult || row.reviewResult === 'null'
                  }"
                >
                  {{ col.formatFn ? col.formatFn(row[col.key], row) : row[col.key] }}
                </span>
              }
              @default {
                {{ col.formatFn ? col.formatFn(row[col.key], row) : row[col.key] }}
              }
            }
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns" sticky></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        tabindex="0"
        [class.selected-row]="selectedRow === row"
        [class.disabled-row]="row.status === 'finished'"
        [attr.data-row-id]="row.id"
        (click)="onRowClick(row)"
      ></tr>
    </table>
  }
</div>
